var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFailed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2054",
    "data-name": "Group 2054",
    transform: "translate(-1226 -478.426)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_119",
    "data-name": "Ellipse 119",
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    transform: "translate(1228 480)",
    fill: "#f87d7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "alert-circle",
    d: "M10,2a8,8,0,1,0,8,8A8,8,0,0,0,10,2Zm0,12a.8.8,0,1,1,.8-.8A.8.8,0,0,1,10,14Zm.8-3.2a.8.8,0,1,1-1.6,0v-4a.8.8,0,1,1,1.6,0Z",
    transform: "translate(1224 476.426)",
    fill: "#f9df9e"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/failed.6e33329990145d0daf00ddd50f0f5c39.svg";
export { ForwardRef as ReactComponent };